import { makeStyles, useTheme } from '@material-ui/core';
import invariant from 'invariant';
import { range } from 'ramda';
import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '../../../icons/draft';
import { Show } from '../../Show/Show';
var useStyles = makeStyles(function (theme) { return ({
    pagination: {
        display: 'inline-block',
        listStyle: 'none',
    },
    paginationItem: {
        fontFamily: theme.typography.fontFamily,
        backgroundColor: 'transparent',
        border: 'none',
        borderRadius: '50%',
        color: theme.palette.text.primary,
        float: 'left',
        fontSize: 14,
        height: theme.spacing(4),
        margin: theme.spacing(0, 0.5),
        outline: 'none',
        width: theme.spacing(4),
        lineHeight: theme.spacing(0.275),
        textAlign: 'center',
    },
    button: {
        cursor: 'pointer',
        '&.active': {
            background: theme.palette.secondary.dark,
            color: theme.palette.common.white,
            '&:disabled': {
                opacity: 1,
            },
            '&:hover,&:active': {
                background: theme.palette.secondary.dark,
            },
        },
        '&:hover,&:active': {
            background: theme.palette.common.white,
        },
        '&:disabled': {
            cursor: 'default',
            opacity: 0.5,
        },
        '&[data-navigation]:disabled': {
            visibility: 'hidden',
        },
    },
    ellipses: {
        '&:hover,&:active': {
            background: 'transparent',
        },
    },
    icon: {
        display: 'block',
        width: theme.spacing(2),
        height: theme.spacing(2),
    },
}); });
var neighbouringPages = 1;
export var Paginator = function (_a) {
    var onChange = _a.onChange, currentPage = _a.currentPage, pageCount = _a.pageCount;
    invariant(currentPage > 0, 'currentPage cannot be less than 1');
    invariant(currentPage <= pageCount, 'currentPage cannot be larger than pageCount');
    var theme = useTheme();
    var styles = useStyles();
    var paginationButton = styles.button + " " + styles.paginationItem;
    var paginationEllipses = styles.ellipses + " " + styles.paginationItem;
    var lowerBound = Math.max(1, currentPage - neighbouringPages);
    var upperBound = Math.min(pageCount, currentPage + neighbouringPages);
    return (React.createElement("nav", { className: styles.pagination },
        React.createElement("button", { "aria-label": "Previous page", className: paginationButton, disabled: currentPage === 1, onClick: function () { return onChange(currentPage - 1); }, "data-name": "pagination-previous-page", "data-navigation": true },
            React.createElement(ChevronLeftIcon, { className: styles.icon, size: "xs", color: theme.palette.common.black })),
        React.createElement(Show, { when: lowerBound > 1 },
            React.createElement("button", { "aria-label": "1", className: paginationButton, onClick: function () { return onChange(1); } }, "1")),
        React.createElement(Show, { when: lowerBound > 2 },
            React.createElement("span", { className: paginationEllipses }, "...")),
        range(lowerBound, upperBound + 1).map(function (pageNumber) { return (React.createElement("button", { "aria-label": "Page " + pageNumber, className: paginationButton + " " + (currentPage === pageNumber ? 'active' : ''), disabled: currentPage === pageNumber, key: pageNumber, onClick: function () { return onChange(pageNumber); }, "data-name": "pagination-page-" + pageNumber }, pageNumber)); }),
        React.createElement(Show, { when: upperBound < pageCount - 1 },
            React.createElement("span", { className: paginationEllipses }, "...")),
        React.createElement(Show, { when: upperBound < pageCount },
            React.createElement("button", { "aria-label": "Page " + pageCount, className: paginationButton, onClick: function () { return onChange(pageCount); } }, pageCount)),
        React.createElement("button", { "aria-label": "Next page", disabled: currentPage === pageCount, onClick: function () { return onChange(currentPage + 1); }, className: paginationButton, "data-name": "pagination-next-page", "data-navigation": true },
            React.createElement(ChevronRightIcon, { className: styles.icon, size: "xs", color: theme.palette.common.black }))));
};
//# sourceMappingURL=Paginator.js.map